import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * Represents the FilterRelationUserAggregatorView class.
 * Extends JetView to create a custom view for filtering user aggregator relations.
 */
export default class FilterRelationUserAggregatorView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'text',
                            name: 'UserPartner', // Input for User Partner
                            type: 'number',
                            minWidth: 200,
                            label: _('Usuario Partner'),
                            labelPosition: 'top',
                            placeholder: _('Usuario Partner'),
                        },
                        {
                            view: 'text',
                            name: 'UserAggregator', // Input for User Aggregator
                            type: 'number',
                            minWidth: 200,
                            label: _('Usuario Aggregato'),
                            labelPosition: 'top',
                            placeholder: _('Usuario Aggregato'),
                        },
                        {
                            view: 'text',
                            name: 'CreatedLocalDate',
                            id: 'Datepicker', // Datepicker input for creation date
                            css: 'reportrange',
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                        },
                        {
                            view: 'datepicker',
                            name: 'Date', // Date input for creation date
                            id: 'Date',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha de Creación'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: moment().format('YYYY-MM-DD'), // Default date value
                            format: '%d %M %Y',
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'button',
                            value: _('Añadir Relación'), // Button to add relation
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 200,
                            hidden: !devConfig.getPermAction(
                                'relationUserAggregatorAdd',
                                'Add', // Permission check for adding relation
                            ),
                            css: 'prm-relationUserAggregatorAdd',
                            click: () => {
                                this.app.callEvent(
                                    'addRelationUserAggregator:button',
                                    [{}], // Trigger event to add relation
                                );
                            },
                        },
                        {
                            view: 'button',
                            value: _('Limpiar'), // Button to clear inputs
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Button to consult/filter data
                            hotkey: 'enter',
                            type: 'form',
                            width: screen == 'small' ? 0 : 0,
                            minWidth: 200,
                            id: 'consultDesk',
                            click: () => {
                                $$('b5').collapse(); // Collapse accordion section
                                const filterdata = this.getRoot().getValues(); // Get form values
                                if (profile.typeDate !== 2) {
                                    delete filterdata['Date']; // Remove Date if not applicable
                                } else {
                                    if (true) {
                                        delete filterdata['Datepicker']; // Remove Datepicker if applicable
                                    }
                                }
                                this.app.callEvent(
                                    'relationUserAggregator:filter',
                                    [filterdata], // Trigger filter event with data
                                );
                            },
                        },
                    ],
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Añadir Relación'), // Button to add relation
                    type: 'form',
                    hidden: !devConfig.getPermAction(
                        'relationUserAggregatorAdd',
                        'Add', // Permission check for adding relation
                    ),
                    css: 'prm-relationUserAggregatorAdd',
                    click: () => {
                        this.app.callEvent('addRelationUserAggregator:button', [{}]); // Trigger event to add relation
                    },
                },
                {
                    view: 'button',
                    value: _('Limpiar'), // Button to clear inputs
                    click: () => {
                        $$('myForm2').clear(); // Clear form inputs
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'), // Button to consult/filter data
                    hotkey: 'enter',
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove Date if not applicable
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove Datepicker if applicable
                            }
                        }
                        this.app.callEvent('relationUserAggregator:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Accordion header for filters
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section for scrollable view
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup', // Popup for filters
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Popup title
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close popup
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2', // Form inside the popup
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm', // Main form
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion if screen size is adequate
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide Date input if not applicable
                $$('Datepicker').show(); // Show Datepicker
            } else {
                if (true) {
                    $$('Date').show(); // Show Date input
                    $$('Datepicker').hide(); // Hide Datepicker
                }
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
